import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'user-form',
  templateUrl: './user-form.component.html',
})
export class UserFormComponent implements OnInit {

  constructor() { }

  // TODO interface
  data: any = {};
  @Input('data') set data$(value) {
    if (value) this.data = value;
  }

  ngOnInit(): void {
  }

}
